export function showOverlay(overlayElement, message) {
  overlayElement.style.display = 'flex';
  overlayElement.textContent = message;
  document.body.style.overflow = 'hidden';
}
export function hideOverlay(overlayElement) {
  overlayElement.style.display = 'none';
  document.body.style.overflow = 'auto';
}